import { RouteObject } from "react-router-dom";
import { ProjectsDevelopmentsPage } from "src/routes/projects/ProjectsDevelopmentsPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { developmentsRoute } from "src/routing/domains/developmentsPaths";

/**
 * `/developments` list page.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `BeamNavbarLayout` → `ProjectsDevelopmentsPage`.
 * Path constants live in `developmentsPaths.ts`. Legacy `Routes.tsx` must not register this path.
 * Development detail SideNav remains on legacy routes until migrated.
 */
export const developmentsRoutes: RouteObject[] = [
  {
    path: developmentsRoute.path,
    Component: AppShell,
    children: [{ Component: BeamNavbarLayout, children: [{ index: true, Component: ProjectsDevelopmentsPage }] }],
  },
];
